export default "__VITE_ASSET__DsZOBwam__"